import React, { Fragment, useState, useEffect } from "react";
import SideMenu from "../../Components/SideMenu";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import Styles from "../../../../Slices/Mof/Styles.json";
import "../../Dashboard.css";
import axios from "axios";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import { useGlobalContext } from "../../../../../context";
import OtherBusinessFormList from "./Components/OtherBusinessFormList";

import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@mui/material/colors";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import Modal from "@mui/material/Modal";
import CircularIndeterminate from "../../../GeneralComponents/CirularProgress";
import StyledDataGrid from "../../../GeneralComponents/StyledDataGrid";
import "../../../../../assets/css/DG.css";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import ApiSettings from '../../../../../Settings/ApiSettings.json'

import UpdateActivityForm from "../Activities/UpdateActivityForm";
import ViewActivity from "../Activities/ViewActivity";

import swal from 'sweetalert';

import Cookies from "universal-cookie";
import UpdateOtherBusinessForm from "./UpdateOtherBusinessForm";
const cookies = new Cookies();

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");

const label = { inputProps: { "aria-label": "توقيع المكلف او وكيله" } };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
};


function OtherBusinessForm(props) {
  const [loading, setLoading] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [activityTotal, setActivityTotal] = useState(0);
  const [activityNumberOfPages, setActivityNumberOfPages] = useState(0);
  const [showBoxOfEditForm, setshowBoxOfEditForm] = useState(false);
  const [showBoxOfViewForm, setshowBoxOfViewForm] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);
  const {otherBusinessForm, fetchData } = useGlobalContext();

  const [columns] = useState([
    { field: "id", headerName: "ت", flex: 0.1 },

    {
      field: "type",
      headerName: "نوع المقتبس / التصريح",
      flex: 1.5,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.other_busniess?.type}
          </div>
        );
      },
    },
    {
      field: "form_number",
      headerName: "الرقم",
      flex: 1,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.form_number}</div>;
      },
    },
    {
      field: "form_date",
      headerName: "التاريخ",
      flex: 0.7,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>
            {rows?.row?.form_date}
          </div>
        );
      },
    },
    {
      field: "issuer",
      headerName: "جهة الاصدار",
      flex: 1,
      renderCell: (rows) => {
        return (
          <div style={{ width: "100%" }}>{rows?.row?.issuer}</div>
        );
      },
    },
    {
      field: "amount",
      headerName: "المبلغ",
      flex: 0.7,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.amount}</div>;
      },
    },
    {
      field: "currency",
      headerName: "العملة",
      flex: 0.5,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.currency}</div>;
      },
    },
    {
      field: "note",
      headerName: "الملاحظات",
      flex: 1,
      renderCell: (rows) => {
        return <div style={{ width: "100%" }}>{rows?.row?.note}</div>;
      },
    },

    {
      field: "actions",
      flex: 1,
      headerName: "الادوات",
      renderCell: (rows) => (
        <strong>
          <IconButton
            style={{ marginLeft: 15 }}
            aria-label="تعديل"
            size="small"
            onClick={() => {
              updateObject(rows.row);
            }}
          >
            <Tooltip title="Edit">
              <ModeEditOutlineRoundedIcon style={{ fill: "#deb12c" }} />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {
              //TODO delete object
              console.log(rows.row);
              deleteRow(rows?.row)
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton>
        </strong>
      ),
    },
  ]);

  const [rows, setRow] = useState([]);
  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1);
  };

  const updateObject = async (object) => {
    setSelectedObject(object);

    setshowBoxOfEditForm(true);
  };
  const viewObject = async (object) => {
    setSelectedObject(object);
    setshowBoxOfViewForm(true);
  };
  const advanceSearch = () => {
    fetchData("OTHER_BUSINESS_FORM", "other_businesses_form/index/"+props?.object?.id, {
      page: pageNumber,
      page_size: pageSize,
    });
  };
  useEffect(() => {
    advanceSearch();
  }, [pageSize, pageNumber]);
  //Reformatting activity object once activity are loaded
  useEffect(() => {
    if (otherBusinessForm && otherBusinessForm.data && otherBusinessForm.data.length > 0) {
      setRow(otherBusinessForm.data);
      setActivityTotal(otherBusinessForm.total);
      setActivityNumberOfPages(otherBusinessForm.last_page);
    }
  }, [otherBusinessForm]);

  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const deleteRow=async(row)=>{
    swal({
      title: "هل انت متئكد?",
      text: "بمجرد مسحك لهذا المقتبس لن تستطيع استرجاعه في ما بعد",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then(async(willDelete) => {
      if (willDelete) {
          let data=null;
          try{
            data=await axios({
                method:'delete',
                url:ApiSettings.apiUrl+'/other_businesses_form/delete',
                data:{
                  other_business_id:row?.id
                },
                headers:{
                    'Content-Type':'application/json',
                    Accept:'application/json',
                }
            })

            if(data){
                if(data.data.status==200){
                    
                      swal("تم حذف المقتبس بنجاح", {
                        icon: "success",
                      });
                    
                    advanceSearch()
                    // setsnackBar({
                    //     ...snackBar,
                    //     open: true,
                    //     severity: "success",
                    //     message: data.data.message,
                    //   });
                }else{
                    setsnackBar({
                        ...snackBar,
                        open: true,
                        severity: "warning",
                        message: data.data.message,
                      });
                }
                setLoading(false)
            }else{
                  setLoading(false)
            }
          }
          catch(err){
            setsnackBar({
                ...snackBar,
                open: true,
                severity: "error",
                message: err.message,
              });
            setLoading(false)

          }
      }
  
    });
  }

  return (
    <div className="Dashboard_MOF1 px-0 pb-6 mx-0 " style={{overflow: 'hidden'}}>
          
            <div
              style={{
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }}
            >
              <OtherBusinessFormList advanceSearch={advanceSearch} object={props?.object} />

              {/* snack alert box here ... */}
              <Snackbar
                open={snackBar.open}
                autoHideDuration={6000}
                onClose={() => {
                  setsnackBar({ ...snackBar, open: false });
                }}
                anchorOrigin={{
                  vertical: snackBar.vertical,
                  horizontal: snackBar.horizontal,
                }}
              >
                <Alert
                  onClose={() => {
                    setsnackBar({ ...snackBar, open: false });
                  }}
                  severity={snackBar.severity}
                  sx={{ width: "100%" }}
                >
                  {snackBar.message}
                </Alert>
              </Snackbar>
            </div>

            <div
              style={{
                height: "calc(100% - 9em)",
                minHeight: 400,
                borderRadius: 10,
                width: "99%",
                height: "450px",
              }}
            >
              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={otherBusinessForm?.total ? otherBusinessForm?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize);
                }}
                components={{
                  Footer: () => null,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params);
                }}
              />
              <Box width="45%" m="auto" sx={{ marginTop: "10px" }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={activityNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p);
                  }}
                />
              </Box>

              <div
                style={{
                  width: "50%",
                  position: "absolute",
                  top: "100px",
                  margin: "0 auto",
                  left: "50%",
                  top: "50%",
                }}
              >
                {loading && <CircularIndeterminate />}
              </div>
            </div>
          

          <Modal
        keepMounted
        open={showBoxOfEditForm || showBoxOfViewForm}
        onClose={() => {
          setshowBoxOfEditForm(false);
          setshowBoxOfViewForm(false);
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            border: "none",
            outline: "none",
            borderRadius: "10px",
            overflow: "scroll",
          }}
          className="modalCroupsCarrier"
        >
          {selectedObject && showBoxOfEditForm && (
            <UpdateOtherBusinessForm object={selectedObject} setshowBoxOfEditForm={setshowBoxOfEditForm} advanceSearch={advanceSearch}/>
          )}
        </Box>
          </Modal>
        
          <br />
          <br />
          <br />

    </div>
  );
}

export default OtherBusinessForm;
